/**
 * Single source of truth for how a ChatStates value is presented in the console.
 *
 * Before this file the same switch was hand-copied into admin-dashboard-home,
 * operator-dashboard-home and chat-history, and the two dashboards had no branch for
 * AGENT (the state every conversation starts in) or TIME_OUT — so a perfectly healthy
 * AI conversation was labelled «نامشخص». Colours had drifted apart too.
 *
 * `i18nKey` is kept so the existing `t(key, default)` call sites in chat-history keep
 * working; no locale file defines these keys today, so the Persian default is what renders.
 */
export const CHAT_STATE_META = {
    AGENT: {label: "ایجنت هوش مصنوعی", color: "processing", i18nKey: "ch.states.agent"},
    WAITING: {label: "در صف اپراتور", color: "orange", i18nKey: "ch.states.waiting"},
    OPERATOR: {label: "در حال پاسخ اپراتور", color: "blue", i18nKey: "ch.states.operator"},
    AGENT_FINISHED: {label: "پایان توسط ایجنت", color: "purple", i18nKey: "ch.states.agent_finished"},
    OPERATOR_FINISHED: {label: "پایان توسط اپراتور", color: "success", i18nKey: "ch.states.operator_finished"},
    // TIME_OUT is produced both by an abandoned registration and by a /cancel while queued;
    // «بسته‌شده بدون پاسخ» is the one wording that is honest about both.
    TIME_OUT: {label: "بسته‌شده بدون پاسخ", color: "red", i18nKey: "ch.states.time_out"},
};

const UNKNOWN_STATE_META = {label: "نامشخص", color: "default", i18nKey: "ch.states.unknown"};

/** Never returns undefined — an unmapped/absent state falls back to «نامشخص». */
export const stateMeta = (state) => CHAT_STATE_META[state] || UNKNOWN_STATE_META;

/**
 * States a conversation cannot come back from. Used to stop live polling and refreshing on chats
 * that can never change again.
 *
 * <p>An unknown state deliberately reads as NOT finished: treating something we do not recognise as
 * over would silently stop updating a conversation that is in fact still running.
 */
const FINISHED_STATES = new Set(["AGENT_FINISHED", "OPERATOR_FINISHED", "TIME_OUT"]);

export const isFinishedState = (state) => FINISHED_STATES.has(state);
